import { useSyncExternalStore } from 'react';

// Store mínimo para compartir el estado del asistente entre AssistantFab (que
// renderiza los paneles) y BottomNav (que lo abre y muestra el estado en el nav).

let state = { voiceStatus: 'idle', openFn: null, startVoiceFn: null };
const listeners = new Set();
function emit() { listeners.forEach((l) => l()); }

export function setVoiceStatus(s) {
  if (state.voiceStatus === s) return;
  state = { ...state, voiceStatus: s };
  emit();
}
export function registerOpen(fn) { state = { ...state, openFn: fn }; }
export function openAssistant() { try { state.openFn && state.openFn(); } catch (_) {} }

// Arranca la voz global (p.ej. el tour de bienvenida). Se llama DENTRO del gesto
// del usuario (iOS exige mic en el tap): cadena SÍNCRONA hasta getUserMedia.
export function registerStartVoice(fn) { state = { ...state, startVoiceFn: fn }; }
export function startVoiceExternal(opts) { try { return state.startVoiceFn && state.startVoiceFn(opts); } catch (_) {} }

function subscribe(l) { listeners.add(l); return () => listeners.delete(l); }
function getSnapshot() { return state; }
export function useAssistantStore() { return useSyncExternalStore(subscribe, getSnapshot); }
